module.exports = __webpack_public_path__ + "img/brand-logo.b0305f47.svg";